
//https://stackoverflow.com/questions/49559009/angular5-deploying-angular-application-to-multiple-clients/49559443#49559443
//https://blog.bennymichielsen.be/2017/07/27/managing-settings-for-an-angular-app-with-vsts/

import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class SettingsProvider {

    private config: any;
    private error: any;

    constructor(private http: HttpClient) {
        // private adalSvc: AdalService) {
    }

    public loadConfig(): Promise<any> {
        return new Promise((resolve, reject) => {
        
        this.http.get('./assets/config/client-config.json').subscribe(
            data => {
                this.config = data;
                console.log('Fetched config');                
                resolve(this.config);
            },
            (err: HttpErrorResponse) => {
                this.error = err; // error path
                console.log('Error Fetching config');
                console.log(this.error);
                reject(this.error);
                
            }
        );
    });
    }

    public get configuration(): any {
        return this.config;
    }

    public get baseUrl(): string {
        return this.config.azureKpisConfig.endpoints.apiEndpoint;
    }


//     public get authHeaders(): HttpHeaders {
//         var headers: HttpHeaders;
//         headers = new HttpHeaders();        
// //        headers = headers.set('Authorization', 'Bearer ' + this.adalSvc.userInfo.token);
//         headers = headers.set('withCredentials', 'true');
//         headers = headers.set('Content-Type', 'application/json; charset=utf-8');
// //		headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.azureKpisConfig.subscription);
//         return headers;
//     }
}